const sidebar = document.getElementById("ocfp-sidebar-nav");
const sidebarToggleBtn = document.getElementById("ocfp-sidebar-toggle-btn");

// Sidebar Toggle
if (sidebarToggleBtn) {
	// openMenu();
	sidebarToggleBtn.addEventListener("click", (e) => {
		if (sidebar.classList.contains("ocfp-sidebar-expanded")) {
			closeMenu(e);
		} else {
			openMenu(e);
		}
	});
}

function openMenu(e) {
	e?.preventDefault();
	sidebarToggleBtn.setAttribute("aria-expanded", "true");
	sidebarToggleBtn.setAttribute("aria-label", "Collapse Menu");
	sidebar.classList.add("ocfp-sidebar-expanded");
}

function closeMenu(e) {
	e?.preventDefault();
	sidebarToggleBtn.setAttribute("aria-expanded", "false");
	sidebarToggleBtn.setAttribute("aria-label", "Expand Menu");
	sidebar.classList.remove("ocfp-sidebar-expanded");
}

// Sidebar Navigation Items
const sidebarMenuNav = document.getElementById("main-menu-menu-list");
if (sidebarMenuNav) {
	const menuItemWithChildren = document.querySelectorAll("#main-menu-menu-list .menu-item-has-children");

	menuItemWithChildren.forEach((item) => {
		const btn = item.querySelector("button");
		btn.addEventListener("click", (e) => {
			e.preventDefault();
			const submenu = item.querySelector(".sub-menu");
			submenu.classList.toggle("ocfp-open-submenu");
			item.classList.toggle("ocfp-open-submenu");
			SubmenuAttributes(btn, submenu);
		});
	});
}

function SubmenuAttributes(btn, submenu) {
	if (submenu.classList.contains("ocfp-open-submenu")) {
		btn.setAttribute("aria-expanded", "true");
	} else {
		btn.setAttribute("aria-expanded", "false");
	}
}

// Keep Submenu opened if submenu item is selected
const sidebarNav = document.querySelector(".ocfp-sidebar-navigation");
// console.log(sidebarNav);
if (sidebarNav) {
	// Keep Submenu opened if submenu item is selected
	// console.log(currentURL.pathname);
	const sidebarNavItemsWithChildren = sidebarNav.querySelectorAll(".current-menu-parent");

	sidebarNavItemsWithChildren.forEach((item) => {
		if (item.querySelectorAll(".current-menu-item")) {
			item.classList.add("ocfp-open-submenu");
			item.querySelector(".sub-menu").classList.add("ocfp-open-submenu");
		}
	});
}
